<template>
	<div
		@click="
            handleClick($event, [
                'inPage__handleClick',
            ])
        "
	>
		<slot />
	</div>
</template>

<script>

import inPageLinks from '../mixins/with-in-page-links.vue'

export default {
	name: 'page',

	mixins: [
		inPageLinks
	],

	computed: {
	},

	methods: {
		handleClick(event, handlers) {
			handlers.map((handler) => {
				this[handler](event)
			})
		},
	},

	data() {
		return {
		}
	},

	created() {
	},

	destroyed() {
	},

	mounted() {
	}
}
</script>
